export const tableTitles: string[] = [
  'vehicleDimensions',
  'loadingSpaceDimensions',
  'weights',
  'body',
  'emissionsConsumption',
  'engine',
];

export const loadingSpaceDimensionsValues = [
  'lengthMax',
  'heightMax',
  'widthMax',
  'widthMin',
  'closed',
  'bootCapacity',
];

export const bodyValues = ['doors', 'seats'];

export const vehicleDimensionsValues = [
  'length',
  'height',
  'width',
  'widthWithRetractedMirrors',
  'wheelbase',
];

export const weightsValues = [
  'payloadMax',
  'kerbWeight',
  'weightMax',
  'permissibleWeightTotal',
  'trailingLoadWithrakesMax',
  'trailingLoadWithoutBrakesMax',
];
